import { Box, CircularProgress } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

export const Loading = ({
  children,
  isLoading = false,
}: {
  children?: any;
  isLoading: boolean;
}) => {
  const loaderRef = useRef<HTMLDivElement | null>(null);

  const loaderElement = loaderRef.current;
  const rect = loaderElement?.getBoundingClientRect();
  const height = !!rect ? window.innerHeight - rect.top : 0;
  const width = !!rect ? window.innerWidth - rect.left : 0;

  const content = isLoading ? (
    <Box
      sx={{
        backgroundColor: 'rgba(255,255,255, 0.5)',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: width + 'px',
        height: height + 'px',
      }}
    >
      <CircularProgress />
    </Box>
  ) : (
    children
  );

  return <div ref={loaderRef}>{content}</div>;
};
